export default "__VITE_ASSET__Cr7Q8BsV__"